module.exports = __webpack_public_path__ + "static/media/DataIntegration.e612e096.svg";